import { TTheme } from '@core/theme'
import { styled } from '@mui/system'

export const NoteItemWrapper = styled('div')<{ theme?: TTheme }>`
    width: 100%;

    .title {
        color: ${({ theme: { colors } }) => colors.greys[500]};
        margin-bottom: 6px;
    }
`

export const NoteText = styled('div')<{ theme?: TTheme }>`
    border-radius: 12px;
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--color-greys-200, #e6e6e6);
    background: var(--color-greys-50, #fcfcfc);
    color: ${({ theme: { colors } }) => colors.greys[900]};
`
